<template>
  <vue-good-table
    :columns="columnsValues"
    :rows="currentCommands"
    :pagination-options="{
        enabled: true,
        perPage: '10',
        perPageDropdown: [10],
        mode: 'records',
        rowsPerPageLabel: 'Reportes por página',
        ofLabel: 'de',
        allLabel: 'Todas',
        prevLabel: 'Anterior',
        nextLabel: 'Siguiente'
      }"
  >
    <div slot="emptystate">No existen resultados</div>
  </vue-good-table>
</template>

<script>
import ThingsService from '../../thingsService.js'
import { ThingActionState, VehicleAction } from '../../constants'
import Utils from '../../utils'

const query = `action=='${VehicleAction.FuelCutOff}' OR action=='${VehicleAction.FuelRestore}'&_sort=created_timestamp%2Bdesc`;

export default {
  props: {
    vehicle: Object
  },

  data: () => ({
    currentPage: 1,
    columnsValues: [
      {
        label: "Comando",
        field: "command",
        sortable: false,
        tdClass: "text-center",
        width: "200px",
        placeholder: "Filtrar por ubicación"
      },
      {
        label: "Estado",
        field: "state",
        sortable: false,
        tdClass: "text-center",
        width: "200px",
        placeholder: "Filtrar por ubicación"
      },
      {
        label: "Fecha y hora",
        sortable: false,
        field: "datetime",
        type: "number",
        tdClass: "text-center",
        placeholder: "Filtrar por velocidad"
      }
    ],
    currentCommands: []
  }),

  mounted() {
    this.getHistoryPage(1)
  },

methods: {
    setPage({ currentPage }) {
      this.currentPage = currentPage;
      this.getHistoryPage(currentPage)
    },

    refreshFirstPage() {
      if (this.currentPage === 1) {
        this.getHistoryPage(1)
      }
    },

    async getHistoryPage(page = 1) {
      const actions = await ThingsService.getActions(this.vehicle.id, `${query}&_limit=10&_page=${page}`)
      this.currentCommands = actions.map(action => ({
        command: action.action === VehicleAction.FuelCutOff ? "Corte" : "Restauración",
        datetime: Utils.formatDatetime(action.last_modified_timestamp),
        state: action.state
      }))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// FuelCutHistory.vue?391b08e2